import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./DispositionWhatsappTemplates.module.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import WhatsappMessagePreview from "../WhatsappMessagePreview/WhatsappMessagePreview";
import {
  whatsappSetupMakretingTabs,
  whatsappSetupTempTabs,
} from "../../mockData";
import { TabContent, TabNavItem } from "../../TabLayout/TabLayout";
import DispositionWhatsappTemplate1 from "./DispositionWhatsappTemplate1";
import DispositionWhatsappTemplate2 from "./DispositionWhatsappTemplate2";
import { fetchSingleTemplate } from "../../../Services/marketingAutomation";
import { setBrowseTemplate } from "../../../Redux/actions";

type props = {
  templatesDirection?: any;
  selectedTemplatesType?: any;
  templatesDirectionCol?: boolean;
  selectedBrowseTemplate?: any;
  browseContactData: any;
  setActiveTabTemp: any;
  fetchBrowseTemp: any;
};

const BrowseWhatsappTemplates: FunctionComponent<props> = ({
  templatesDirection,
  selectedTemplatesType,
  templatesDirectionCol,
  selectedBrowseTemplate,
  browseContactData,
  setActiveTabTemp,
  fetchBrowseTemp,
}) => {
  const [activeTab, setActiveTab] = useState<string | number>("Pre Launch");
  const [selectedSubDisposition, setSelectedSubDisposition] = useState("");
  const dispatcher = useDispatch();
  const [selectedContact, setSelectedContact] = useState<string | number>(
    browseContactData?.selectedBrowseTemplate?.WATID
   || browseContactData?.selectedBrowseTemplate?.OTID
      || 0
  );
  const [templateIdType,setTemplateIdType] = useState<string>("");

  const fetchSingleTemp = async (selectedTemplateId: any) => {
    const templateRes = await fetchSingleTemplate(selectedTemplateId, templateIdType);
    selectedBrowseTemplate(templateRes);
    dispatcher(setBrowseTemplate(templateRes));
  };
  useEffect(() => {
    fetchSingleTemp(selectedContact);
  }, [selectedContact, fetchBrowseTemp]);

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedContact(e.target.value);
  };
  useEffect(() => {
    setActiveTabTemp(activeTab);
  }, [activeTab]);

  const DispositionTemplates: FunctionComponent<{
    title: any;
    templates: any;
  }> = ({ title, templates }) => {
    return (
      <div style={{ marginBottom: "1rem" }}>
        <div
          className={styles.whatsappPreviewMessagesContainer}
          onClick={() => {
            if (selectedSubDisposition === title) {
              setSelectedSubDisposition("");
            } else {
              setSelectedSubDisposition(title);
            }
          }}
        >
          {selectedSubDisposition === title ? (
            <ExpandMoreIcon />
          ) : (
            <NavigateNextIcon />
          )}
          <p>{title}</p>
        </div>
        {selectedSubDisposition === title && (
          <div
            className={
              templatesDirectionCol
                ? styles.whatsappPreviewMessagesCol
                : styles.whatsappPreviewMessages
            }
          >
            {templates && templates.length > 0 ? (
              templates.map((value: any, index: any) => {
                return (
                  <WhatsappMessagePreview
                    key={value?.WATID || value?.OTID}
                    selected={selectedContact.toString()}
                    handleChange={(e)=>{
                      handleRadioChange(e);
                      if(value?.WATID){
                        setTemplateIdType("WATID")
                      }else{
                        setTemplateIdType("OTID")
                      }
                    }}
                    templateTitle={
                      `Template ${index+1}`
                    }
                    id={value?.WATID?.toString() || value?.OTID?.toString()}
                    showRadioButton={true}
                    children={
                      <DispositionWhatsappTemplate1
                        msgContent={value?.MSG_CONTENT}
                      />
                    }
                  />
                );
              })
            ) : (
              <div>No Templates Available</div> // Render a fallback message
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div className={styles.dispositionTemplatesContainer}>
        <div className={styles.dispositionTabsContainer}>
          {selectedTemplatesType == "Disposition based"
            ? whatsappSetupTempTabs?.map((tab, index) => {
                return (
                  <TabNavItem
                    key={index}
                    id={tab.id}
                    title={tab.title}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    className={styles.tabContainer}
                    activeClass={styles.tabContainerActive}
                  />
                );
              })
            : whatsappSetupMakretingTabs?.map((tab, index) => {
                return (
                  <TabNavItem
                    key={index}
                    id={tab.id}
                    title={tab.title}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    className={styles.tabContainer}
                    activeClass={styles.tabContainerActive}
                  />
                );
              })}
        </div>
        <div className={styles.templatesContainer}>
          {/* <div className={styles.searchContainer}>
            <input type="text" placeholder="" onChange={(e)=>{
              setSearchQuery(e.target.value)
              }} value={searchQuery}/>
            <AiOutlineSearch
                color={"#000"}
                style={{ cursor: 'pointer' }}
                size={18}
            />
        </div> */}
          {
            // whatsappSetupMakretingTabs.map((tab, index) => {
            // return (
            // <TabContent
            //   id={tab.id}
            //   activeTab={activeTab}
            //   className="tab-content"
            // >
            //   <DispositionTemplates />
            // </TabContent>
            <div className={styles.templatesContainer}>
              <TabContent
                id={activeTab}
                activeTab={activeTab}
                className="tab-content"
              >
                {fetchBrowseTemp?.map((item: any, index: any) => {
                  let keyName = Object.keys(item);
                  const templates = item[keyName[0]]?.value || [];
                  return (
                    <DispositionTemplates
                      title={keyName[0]}
                      templates={templates}
                    />
                  );
                })}
              </TabContent>
            </div>
            // <TabContent
            //   id={"offers"}
            //   activeTab={activeTab}
            //   className="tab-content"
            // >
            //   <DispositionTemplates />
            // </TabContent>
            // <TabContent
            //   id={"generic"}
            //   activeTab={activeTab}
            //   className="tab-content"
            // >
            //   <DispositionTemplates />
            // </TabContent>
            // )
            // })
          }
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    browseContactData: state.browseContactData,
  };
};

export default connect(mapStateToProps)(BrowseWhatsappTemplates);
